module.exports = __webpack_public_path__ + "static/media/11.97b5b319.jpg";